import React, { useState } from 'react';
import { Modal, Form, Button, Message } from 'rsuite';

import { useAuth } from './AuthContext';
import authFetch from '../../helpers/authFetch';
import { usePreferences } from '../Preferences/PreferencesContext';
import { getThemeColors } from '../../helpers/themeColors';

const USERNAME_MIN = 2;
const USERNAME_MAX = 50;

const SetUsernameModal = () => {
  const { user, updateUser } = useAuth();
  const { preferences } = usePreferences();
  const t = getThemeColors(preferences.theme);
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!user || user.username !== null) return null;

  const handleSubmit = async () => {
    setError('');
    const trimmed = username.trim();

    if (!trimmed) {
      setError('Display name is required');
      return;
    }
    if (trimmed.length < USERNAME_MIN || trimmed.length > USERNAME_MAX) {
      setError(`Display name must be between ${USERNAME_MIN} and ${USERNAME_MAX} characters`);
      return;
    }

    setLoading(true);
    try {
      const res = await authFetch('/auth/me', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: trimmed }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || 'Failed to set display name');
        return;
      }

      updateUser(data.token);
    } catch {
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open backdrop="static" keyboard={false} size="xs">
      <Modal.Header closeButton={false}>
        <Modal.Title>Set Your Display Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: 16, color: t.textMuted }}>
          Choose a display name that other users will see. You can change it later in Settings.
        </p>
        {error && (
          <Message type="error" showIcon style={{ marginBottom: 12 }}>
            {error}
          </Message>
        )}
        <Form fluid>
          <Form.Group>
            <Form.ControlLabel>Display Name</Form.ControlLabel>
            <Form.Control
              name="username"
              value={username}
              onChange={setUsername}
              placeholder="Choose a display name"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance="primary" loading={loading} onClick={handleSubmit} block>
          Save Display Name
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SetUsernameModal;
